import { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './Lightbox.css';

export default function Lightbox({ images, currentIndex, onClose, onNext, onPrev }) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Distance minimale pour détecter un swipe (en pixels)
  const minSwipeDistance = 50;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    
    // Empêche le scroll sur mobile quand lightbox est ouverte
    document.body.style.overflow = 'hidden';
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, onNext, onPrev]);

  // Gestion du swipe tactile
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      onNext(); // Swipe gauche = image suivante
    }
    if (isRightSwipe) {
      onPrev(); // Swipe droite = image précédente
    }
  };

  return (
    <div className="lightbox">
      <button onClick={onClose} className="lightbox-close" aria-label="Fermer">
        <X size={28} />
      </button>
      
      {images.length > 1 && (
        <>
          <button onClick={onPrev} className="lightbox-prev" aria-label="Image précédente">
            <ChevronLeft size={40} />
          </button>
          
          <button onClick={onNext} className="lightbox-next" aria-label="Image suivante">
            <ChevronRight size={40} />
          </button>
        </>
      )}
      
      <div 
        className="lightbox-content"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <img
          src={images[currentIndex]}
          alt={`Image ${currentIndex + 1}`}
          className="lightbox-image"
        />
      </div>

      {images.length > 1 && (
        <div className="lightbox-counter">
          {currentIndex + 1} / {images.length}
        </div>
      )}
    </div>
  );
}